export const BAR_THICKNESS = 5;
